import React from 'react'

import Pattern from '../../images/icons/pattern.svg'
import PatternPlus from '../../images/icons/pattern-plus.svg'
import styles from './pattern-logo.module.scss'
import { type IconSizes } from '../Icons/Icon.models'

type PatternLogoProps = {
  /** Optional size for the logo. Defaults to 20px. */
  logoSize?: IconSizes | '30px'
  /** Optional type of logo to display. Defaults to 'pattern'. */
  logoType?: 'pattern' | 'patternPlus'
  /** Optional prop to add a test id to the PatternLogo for QA testing */
  qaTestId?: string
}

const PatternLogo = ({
  logoSize = '20px',
  logoType = 'pattern',
  qaTestId = 'pattern-logo',
}: PatternLogoProps): React.JSX.Element => {
  const inlineStyles = {
    '--logo-height': logoSize,
    '--logo-width': logoSize,
  } as React.CSSProperties
  return (
    <div className={styles.logoWrapper} qa-test-id={qaTestId}>
      {logoType === 'pattern' ? (
        <Pattern className={styles.patternLogo} style={inlineStyles} />
      ) : (
        <PatternPlus className={styles.patternLogo} style={inlineStyles} />
      )}
    </div>
  )
}

export default PatternLogo
